import React, {memo} from 'react'
import TextField from '@material-ui/core/TextField';
import InputAdornment from "@material-ui/core/InputAdornment";

const onlyNumbers = (e) => {
    const key = window.event ? e.which : e.keyCode;
    if (key < 48 || key > 57) {
        e.preventDefault();
    }
}

const AppInputNumber = memo(
    ({
         id,
         name,
         label,
         value = '',
         required = false,
         onChange,
         block = true,
         onKeyDown = null,
         onBlur = null,
         disabled = false,
         icon = null,
         placeholder = '',
     }) => {

        let style = {};

        if (block) {
            style.width = '100%'
        }

        return (
            <TextField
                type='number'
                required={required}
                value={value}
                placeholder={placeholder}
                onKeyPress={onlyNumbers}
                onChange={onChange}
                onKeyDown={onKeyDown}
                onBlur={onBlur}
                id={id}
                name={name}
                label={label}
                InputProps={{
                    startAdornment: icon ? (
                        <InputAdornment position="start">
                            {icon}
                        </InputAdornment>
                    ) : null,
                }}
                style={style}
                disabled={disabled}
                variant="outlined"/>
        );
    })
export default AppInputNumber
